export default __webpack_public_path__ + "static/media/cp_ggl_ggl.66ae25be.svg";